"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DspProviderToJSON = exports.DspProviderFromJSONTyped = exports.DspProviderFromJSON = exports.DspProvider = void 0;
/**
 *
 * @export
 */
exports.DspProvider = {
    TradeDesk: 'TRADE_DESK',
    Dv360: 'DV360',
    MagniteSsp: 'MAGNITE_SSP'
};
function DspProviderFromJSON(json) {
    return DspProviderFromJSONTyped(json, false);
}
exports.DspProviderFromJSON = DspProviderFromJSON;
function DspProviderFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.DspProviderFromJSONTyped = DspProviderFromJSONTyped;
function DspProviderToJSON(value) {
    return value;
}
exports.DspProviderToJSON = DspProviderToJSON;
